import { gql } from "@apollo/client";

export const CREATE_MASTER_DATA_PRODUCT_PRICE = gql`
  mutation CreateMasterDataProductPrice(
    $params: CreateMasterDataProductPriceInput!
  ) {
    createMasterDataProductPrice(params: $params) {
      productPriceId
      productId
      purchaserId
      productPrice
      startDate
    }
  }
`;
